import { render, staticRenderFns } from "./BlacklistModal.vue?vue&type=template&id=1707df42&"
import script from "./BlacklistModal.vue?vue&type=script&lang=js&"
export * from "./BlacklistModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports